import { createApiConstants } from '@saucelabs/sl-util-redux';

import { NAMESPACE } from './../../constants';

const LSM_CHANNEL_CONNECT = createApiConstants(NAMESPACE, 'LSM_CHANNEL_CONNECT');
const LSM_CHANNEL_STATUS_GET = createApiConstants(NAMESPACE, 'LSM_CHANNEL_STATUS_GET');
const LSM_GET_SCREENSHOT = createApiConstants(NAMESPACE, 'LSM_GET_SCREENSHOT');
const LSM_GET_SESSION_INFO = createApiConstants(NAMESPACE, 'LSM_GET_SESSION_INFO');
const LSM_SESSION_CLOSE = createApiConstants(NAMESPACE, 'LSM_SESSION_CLOSE');
const LSM_SESSION_CREATE = createApiConstants(NAMESPACE, 'LSM_SESSION_CREATE');
const LSM_SESSION_RECONNECT = createApiConstants(NAMESPACE, 'LSM_SESSION_RECONNECT');

const LSM_SECONDS_LEFT_UPDATE = `${NAMESPACE}/LSM_SECONDS_LEFT_UPDATE`;

export default {
  LSM_CHANNEL_CONNECT,
  LSM_CHANNEL_STATUS_GET,
  LSM_GET_SCREENSHOT,
  LSM_GET_SESSION_INFO,
  LSM_SECONDS_LEFT_UPDATE,
  LSM_SESSION_CLOSE,
  LSM_SESSION_CREATE,
  LSM_SESSION_RECONNECT,
};
